/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import { withStyles } from 'material-ui/styles';
import Popover from 'react-popover';
import { Grid } from 'material-ui';

const styles = theme => ({});
/**
 * Componente para mostrar un popover de informacion complejo sobre cierto texto.
 * Este componente genera un elemento <span>label</span> con la propiedad label en su interior. cuando hacer rollover muestra el contenido interno.
 */
class InformationPopOver extends React.Component {
    state = {
        popperOpen: false
    };

    handlePopoverOpen = event => {
        this.setState({ popperOpen: true });
    };

    handlePopoverClose = () => {
        this.setState({ popperOpen: false });
    };

    render() {
        const { classes, position, color } = this.props;
        const { popperOpen } = this.state;
        const popoverProps = {
            isOpen: popperOpen,
            place: position,
            body: [
                <Grid container wrap="nowrap" spacing={8}>
                    <Grid item>
                        {this.props.icon ? this.props.icon : ''}
                    </Grid>
                    <Grid item xs>
                        {this.props.children}
                    </Grid>
                </Grid>
            ],
            className: 'PopOver' + this.props.className,
            
        };
        return (
            <Popover {...popoverProps}>
                <span onMouseOver={this.handlePopoverOpen}
                    onMouseOut={this.handlePopoverClose} className={this.props.className}>{this.props.label}</span>
            </Popover>
        );
    }
}

InformationPopOver.defaultProps = {
    position: 'above',
    color: ''
}

export default withStyles(styles)(InformationPopOver);


// WEBPACK FOOTER //
// ./src/ui/InformationPopOver.js